import React from 'react'
import Main from '../../Main'
import image from '../../../assets/img/sponsorship.jpg'

const styles = {
  fontSize: '50px'
}

const NotFound = () => (
  <Main>
    <div className="island">
      <h1 style={styles}><img className="img-thumbnail img-rounded" src={image} alt="2 children" /> Sorry, nothing found.</h1>
    </div>
  </Main>
)

export default NotFound